import React, {forwardRef, useImperativeHandle, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Divider, message, Modal, Typography, Upload} from 'antd';
import filesize from 'filesize';

import {PlusOutlined} from '@/icons';
import PreviewModal from '../UploadWallModal/PreviewModal';
import MomentUpload from './MomentUpload';

const UploadModal = forwardRef(
    ({type, modalTitle, itemId, category = 'category', afterUpload, afterCloseModal}, ref) => {
        const {key} = type;
        console.log(type);
        const previewModalRef = useRef();
        const [visible, setVisible] = useState(false);

        const isImage = key === 'image';

        // 附件上传后的展示方式
        const listType = isImage ? 'picture-card' : 'picture';

        function showModal() {
            setVisible(true);
        }

        function closeModal() {
            setVisible(false);
        }

        useImperativeHandle(ref, () => ({
            showModal,
            closeModal,
        }));

        function onUploadChange({file}) {
            if (file.status === 'done') {
                const {
                    response: {data},
                } = file;
                afterUpload && afterUpload(data);
            }
        }

        function beforeUpload(file) {
            const {width, height, maxSize} = type;
            console.log(width, height, maxSize);
            if (isImage) return checkSize(file, maxSize) && checkWH(file, width, height);
            else return checkSize(file, maxSize);
            //
            // // Upload.LIST_IGNORE 算是 antd 对于 beforeUpload 的 hack
            // // 如果返回 false 的话，该文件缩略图仍然会显示在预览列表中，
            // // 所以开发方新增了这个特定的属性用于处理这个问题
            // return Upload.LIST_IGNORE;
        }

        function checkSize(file, maxSize) {
            const {size} = file;
            if (size <= 5) {
                message.warn('文件必须大于 5 个字节');
                return false;
            }
            if (!maxSize || size <= maxSize) {
                return true;
            } else {
                message.warn('文件大小不能超过 ' + filesize(maxSize) + ', 请删除');
                return false;
            }
        }

        function checkWH(file, width, height) {
            return new Promise(function (resolve, reject) {
                let filereader = new FileReader();
                filereader.onload = e => {
                    let src = e.target.result;
                    const image = new Image();
                    image.onload = () => {
                        if ((width && image.width > width) || (height && image.height > height)) {
                            message.warn(`图片宽高必须小于 ${width} * ${height}, 请删除并重新上传`);
                            reject();
                        } else {
                            resolve();
                        }
                    };
                    image.onerror = reject;
                    image.src = src;
                };
                filereader.readAsDataURL(file);
            });
        }

        function onPreview(file) {
            const {key} = type;
            if (key === 'image' || key === 'video') {
                if (file.response) {
                    previewModalRef.current.showModal(
                        file.response.data[0].urls.file,
                        key === 'image'
                    );
                } else message.error('无法预览,请删除该图片');
                // previewModalRef.current.showModal(file.thumbUrl, key === 'image');
            }
        }

        function onOk() {
            afterCloseModal && afterCloseModal();
            closeModal();
        }

        // const accept = type.accept && type.accept !== '*' ? type.accept : null;

        return (
            <Modal
                destroyOnClose
                width={800}
                maskClosable={false}
                visible={visible}
                title={modalTitle}
                onCancel={closeModal}
                onOk={onOk}
                cancelButtonProps={{style: {display: 'none'}}}
            >
                {console.log('...', type)}
                <div>
                    <Typography.Text type="secondary">
                        {type.accept && `格式支持： ${type.accept}, `}
                        {type.maxSize && `文件大小不超过 ${filesize(type.maxSize)}, `}
                        {type.maxCount && `文件个数不超过 ${type.maxCount}个, `}
                        {isImage &&
                            type.width &&
                            type.height &&
                            `图片大小不超过 ${type.width} * ${type.height}`}
                    </Typography.Text>
                    <Divider />
                </div>
                <MomentUpload
                    category={category}
                    accept={type.accept}
                    listType={listType}
                    beforeUpload={beforeUpload}
                    onPreview={onPreview}
                    onChange={onUploadChange}
                    maxCount={type.maxCount}
                >
                    {isImage ? (
                        <div>
                            <PlusOutlined />
                            <div style={{marginTop: 8}}>上传</div>
                        </div>
                    ) : (
                        <div>
                            <Button type="primary" icon={<PlusOutlined />}>
                                上传
                            </Button>
                        </div>
                    )}
                </MomentUpload>

                <PreviewModal ref={previewModalRef} />
            </Modal>
        );
    }
);

UploadModal.displayName = 'UploadModal';

UploadModal.propTypes = {
    type: PropTypes.shape({
        key: PropTypes.string,
        label: PropTypes.string,
        maxCount: PropTypes.number,
        maxSize: PropTypes.number,
        accept: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
    }),
    modalTitle: PropTypes.string.isRequired,
    itemId: PropTypes.string,
    category: PropTypes.string,
    afterUpload: PropTypes.func,
    afterCloseModal: PropTypes.func,
};

export default UploadModal;
